const EmptyLayout = ({ children = null }) => (
  <div className="p-6 bg-white-subtle h-full w-full">
    {children}
  </div>
)

export default EmptyLayout;
